module.exports = __webpack_public_path__ + "static/media/ki.e366bd7a.svg";